<div class="row">
  @for (product of products$|async; track product.id; let i = $index) {
    <div class="col-sm-6 col-lg-4 mb-4">
      <article
        [maxRatings]="2"
        [product]="product"
        [index]="i"
        app-product-widget
        eventSourceName="storyblok-product-list"
      ></article>
    </div>
  }
</div>

@for (error of errors; track error) {
  <h3>{{error}}</h3>
}
